function composeEventHandlersUtil() {
  for (var _len = arguments.length, eventHandlers = new Array(_len), _key = 0; _key < _len; _key++) {
    eventHandlers[_key] = arguments[_key];
  }
  return event => {
    eventHandlers.forEach(handler => {
      if (typeof handler === 'function' && !event.isDefaultPrevented()) {
        handler(event);
      }
    });
  };
}
export { composeEventHandlersUtil };